// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__FKA9K","form":"Modal_form__xjHNi","closeModal":"Modal_closeModal__N3iI5","btnSubmit":"Modal_btnSubmit__Eikv3","rowBtnForm":"Modal_rowBtnForm__fMvbr"};